import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LotSizingFillRateContent } from './component/lot-sizing-fill-rate-content';
import { LotSizingFillRateMissingVolumes } from './component/lot-sizing-fill-rate-missing-volumes';
import { LotSizingFillRateNoProductSelected } from './component/lot-sizing-fill-rate-no-product-selected';
import { useLotSizingFillRate } from './hooks/use-lot-sizing-fill-rate';

type LotSizingFillRateProps = {
  lotSizingId: string;
};

export function LotSizingFillRate({ lotSizingId }: LotSizingFillRateProps) {
  const { t } = useTranslation('lotSizing');
  const {
    currentVolume,
    totalVolume,
    fillRate,
    totalContainers,
    missingProductVolumes,
    noProductSelected,
  } = useLotSizingFillRate({ lotSizingId });

  return (
    <Card className='gap-3'>
      <CardHeader>
        <CardTitle>{t('fillRateTitle')}</CardTitle>
      </CardHeader>
      <CardContent className='flex min-h-40 flex-col justify-center'>
        {missingProductVolumes.length > 0 ? (
          <LotSizingFillRateMissingVolumes
            missingProductVolumes={missingProductVolumes}
          />
        ) : noProductSelected ? (
          <LotSizingFillRateNoProductSelected />
        ) : (
          <LotSizingFillRateContent
            currentVolume={currentVolume}
            fillRate={fillRate}
            totalContainers={totalContainers}
            totalVolume={totalVolume}
          />
        )}
      </CardContent>
    </Card>
  );
}
